export const SET_METEOROLOGICAL_STATISTICS_AVAILABLE_FIELDS = 'SET_METEOROLOGICAL_STATISTICS_AVAILABLE_FIELDS'

export const setMeteorologicalStatsAvailableFields = fieldsIds => ({
  type: SET_METEOROLOGICAL_STATISTICS_AVAILABLE_FIELDS,
  fieldsIds
})
